<template>
  <div class="layout-left">
    <el-scrollbar>
      <el-menu
        :default-active="navMenuDefault"
        class="el-menu-vertical-demo"
        :collapse="isCollapse"
        router
        unique-opened
        @select="handleNavMenuClick"
      >
        <el-menu-item index="/">
          <i class="iconfont iconhome" />
          <span slot="title">首页</span>
        </el-menu-item>
        <!-- <el-menu-item
                    index="/resource/employee/index"
                >
                    <i class="iconfont icon-zhanghaoguanli2" />
                    <span slot="title">账号管理</span>
                </el-menu-item>
                <el-menu-item
                    index="/resource/vehicle/index"
                >
                    <i
                        class="iconfont icon-cheliangguanli-xi"
                    />
                    <span slot="title">车辆管理</span>
                </el-menu-item>
                <el-menu-item
                    index="/vehiclerta/vehicle_business/findVehicles"
                >
                    <i class="iconfont icon-jiankongzhongxin" />
                    <span slot="title">车辆监控管理</span>
                </el-menu-item>
                <el-submenu
                    v-for="(item, index) in 1"
                    :key="index"
                    index="1"
                >
                    <template slot="title">
                        <i class="iconfont icon-dingwei" />
                        <span slot="title">车辆位置管理</span>
                    </template>
                    <el-menu-item
                        index="/vehiclerta/vehicle_business/location"
                    >
                        <span slot="title">实时位置</span>
                    </el-menu-item>
                    <el-menu-item
                        index="/vehiclerta/vehicle-location-history/index"
                    >
                        <span slot="title">车辆轨迹查询</span>
                    </el-menu-item>
                </el-submenu> -->
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
</style>

<style scoped>
.el-scrollbar {
  left: 0;
  top: 45px;
  bottom: -15px;
  position: fixed;
  z-index: 99;
}
.el-scrollbar__wrap {
  overflow: scroll;
  overflow-x: auto;
}
.is-show-down /deep/ .el-icon-arrow-right {
  display: none;
}
.layout-left >>> .el-scrollbar__view,
.el-scrollbar__view,
.el-menu--collapse,
.el-menu-vertical-demo {
  border: 0;
  min-height: 100%;
}
.layout-left >>> .el-scrollbar__view {
  border-right: 1px solid #eee;
  background: #fff;
}
.layout-left .iconfont {
  margin-right: 8px;
}
</style>

<script>
import navMenus from '@/utils/vueMenus';

export default {
  data() {
    return {
      navMenus,
    };
  },
  computed: {
    navMenuDefault() {
      return this.$store.state.NavMenuActive;
    },
    isCollapse() {
      return this.$store.state.Layout.isCollapse;
    },
  },
  methods: {
    // 选中的tab
    handleNavMenuClick() {
      // let arr = key.split('-');
      // arr.forEach()
      // console.log(key, keyPath);
    },
  },
};
</script>
